import { render, staticRenderFns } from "./HejinWelfare.vue?vue&type=template&id=36bdcd66&scoped=true&"
import script from "./HejinWelfare.vue?vue&type=script&lang=js&"
export * from "./HejinWelfare.vue?vue&type=script&lang=js&"
import style0 from "./HejinWelfare.vue?vue&type=style&index=0&id=36bdcd66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bdcd66",
  null
  
)

export default component.exports